const PromotionApplicationTypeEnum = Object.freeze({
  VARIACAO: "VARIACAO",
  CATEGORIA: "CATEGORIA",
  COLECAO: "COLECAO",
  PRODUTO: "PRODUTO",
});

export default PromotionApplicationTypeEnum;
